const isNull = (value) => {
    let val = typeof value === 'string' ? value.trim() : value;
    if (
        val === '' ||
        val === 0 ||
        val === '0' ||
        val === 'Null' ||
        val === null ||
        val === 'null' ||
        val === '0.00' ||
        val === undefined) {
        return true
    } else {
        return false
    }
}

export default isNull